import referencePrice from './referencePrice.vue'
export default referencePrice
